module.exports = __webpack_public_path__ + "media/images/about_us_1-81dcccfaa0efe51d9abadca20ed3dfad.webp";